// extracted by mini-css-extract-plugin
export default {"btn":"Attach_btn__Q01e4","list":"Attach_list__ffuaL","delete":"Attach_delete__Alt2N","title":"Attach_title__FXXC4","fileName":"Attach_fileName__kKe9N"};